// Actions
import {
  SET_AMERICAN_INDIAN_OR_ALASKA_NATIVE,
  SET_ASIAN,
  SET_BLACK_OR_AFRICAN_AMERICAN,
  SET_HISPANIC_OR_LATIN,
  SET_NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER,
  SET_WHITE,
  SET_MIXED_RACE,
  SET_OTHER,
  SET_ETHNICITY_STATE
} from "../actionTypes/ethnicity.actionTypes";

// Classes
import { EthnicityReducerState } from "../classes/ethnicity.classes";

export interface ISetEthnicityAction {
  type: string;
  payload: boolean;
}

export function setAmericanIndianOrAlaskaNative(
  americanIndianOrAlskaNative: boolean
): ISetEthnicityAction {
  return {
    type: SET_AMERICAN_INDIAN_OR_ALASKA_NATIVE,
    payload: americanIndianOrAlskaNative
  };
}

export function setAsian(asian: boolean): ISetEthnicityAction {
  return { type: SET_ASIAN, payload: asian };
}

export function setBlackOrAfricanAmerican(
  blackOrAfricanAmerican: boolean
): ISetEthnicityAction {
  return {
    type: SET_BLACK_OR_AFRICAN_AMERICAN,
    payload: blackOrAfricanAmerican
  };
}

export function setHispanicOrLatin(
  hispanicOrLatin: boolean
): ISetEthnicityAction {
  return { type: SET_HISPANIC_OR_LATIN, payload: hispanicOrLatin };
}

export function setNativeHawaiianOrOtherPacificIslander(
  nativeHawaiianOrOtherPacificIslander: boolean
): ISetEthnicityAction {
  return {
    type: SET_NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER,
    payload: nativeHawaiianOrOtherPacificIslander
  };
}

export function setWhite(white: boolean): ISetEthnicityAction {
  return { type: SET_WHITE, payload: white };
}

export function setMixedRace(mixedRace: boolean): ISetEthnicityAction {
  return { type: SET_MIXED_RACE, payload: mixedRace };
}

export function setOther(other: boolean): ISetEthnicityAction {
  return { type: SET_OTHER, payload: other };
}

export interface ISetEthnicityStateAction {
  type: string;
  payload: EthnicityReducerState;
}

export function setEthnicityState(
  state: EthnicityReducerState
): ISetEthnicityStateAction {
  return { type: SET_ETHNICITY_STATE, payload: state };
}
try {
    // @ts-ignore
    setAmericanIndianOrAlaskaNative.displayName = "setAmericanIndianOrAlaskaNative";
    // @ts-ignore
    setAmericanIndianOrAlaskaNative.__docgenInfo = { "description": "", "displayName": "setAmericanIndianOrAlaskaNative", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setAmericanIndianOrAlaskaNative"] = { docgenInfo: setAmericanIndianOrAlaskaNative.__docgenInfo, name: "setAmericanIndianOrAlaskaNative", path: "src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setAmericanIndianOrAlaskaNative" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setAsian.displayName = "setAsian";
    // @ts-ignore
    setAsian.__docgenInfo = { "description": "", "displayName": "setAsian", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setAsian"] = { docgenInfo: setAsian.__docgenInfo, name: "setAsian", path: "src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setAsian" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setBlackOrAfricanAmerican.displayName = "setBlackOrAfricanAmerican";
    // @ts-ignore
    setBlackOrAfricanAmerican.__docgenInfo = { "description": "", "displayName": "setBlackOrAfricanAmerican", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setBlackOrAfricanAmerican"] = { docgenInfo: setBlackOrAfricanAmerican.__docgenInfo, name: "setBlackOrAfricanAmerican", path: "src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setBlackOrAfricanAmerican" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setHispanicOrLatin.displayName = "setHispanicOrLatin";
    // @ts-ignore
    setHispanicOrLatin.__docgenInfo = { "description": "", "displayName": "setHispanicOrLatin", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setHispanicOrLatin"] = { docgenInfo: setHispanicOrLatin.__docgenInfo, name: "setHispanicOrLatin", path: "src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setHispanicOrLatin" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setNativeHawaiianOrOtherPacificIslander.displayName = "setNativeHawaiianOrOtherPacificIslander";
    // @ts-ignore
    setNativeHawaiianOrOtherPacificIslander.__docgenInfo = { "description": "", "displayName": "setNativeHawaiianOrOtherPacificIslander", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setNativeHawaiianOrOtherPacificIslander"] = { docgenInfo: setNativeHawaiianOrOtherPacificIslander.__docgenInfo, name: "setNativeHawaiianOrOtherPacificIslander", path: "src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setNativeHawaiianOrOtherPacificIslander" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setWhite.displayName = "setWhite";
    // @ts-ignore
    setWhite.__docgenInfo = { "description": "", "displayName": "setWhite", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setWhite"] = { docgenInfo: setWhite.__docgenInfo, name: "setWhite", path: "src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setWhite" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setMixedRace.displayName = "setMixedRace";
    // @ts-ignore
    setMixedRace.__docgenInfo = { "description": "", "displayName": "setMixedRace", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setMixedRace"] = { docgenInfo: setMixedRace.__docgenInfo, name: "setMixedRace", path: "src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setMixedRace" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setOther.displayName = "setOther";
    // @ts-ignore
    setOther.__docgenInfo = { "description": "", "displayName": "setOther", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setOther"] = { docgenInfo: setOther.__docgenInfo, name: "setOther", path: "src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setOther" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setEthnicityState.displayName = "setEthnicityState";
    // @ts-ignore
    setEthnicityState.__docgenInfo = { "description": "", "displayName": "setEthnicityState", "props": { "americanIndianOrAlaskaNative": { "defaultValue": null, "description": "", "name": "americanIndianOrAlaskaNative", "required": false, "type": { "name": "boolean" } }, "asian": { "defaultValue": null, "description": "", "name": "asian", "required": false, "type": { "name": "boolean" } }, "blackOrAfricanAmerican": { "defaultValue": null, "description": "", "name": "blackOrAfricanAmerican", "required": false, "type": { "name": "boolean" } }, "hispanicOrLatin": { "defaultValue": null, "description": "", "name": "hispanicOrLatin", "required": false, "type": { "name": "boolean" } }, "nativeHawaiianOrOtherPacificIslander": { "defaultValue": null, "description": "", "name": "nativeHawaiianOrOtherPacificIslander", "required": false, "type": { "name": "boolean" } }, "white": { "defaultValue": null, "description": "", "name": "white", "required": false, "type": { "name": "boolean" } }, "mixedRace": { "defaultValue": null, "description": "", "name": "mixedRace", "required": false, "type": { "name": "boolean" } }, "other": { "defaultValue": null, "description": "", "name": "other", "required": false, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setEthnicityState"] = { docgenInfo: setEthnicityState.__docgenInfo, name: "setEthnicityState", path: "src/shared/containers/Filter/Demographics/Ethnicity/actionCreators/ethnicity.actionCreators.ts#setEthnicityState" };
}
catch (__react_docgen_typescript_loader_error) { }